import { notification } from 'antd';
import { ReactComponent as Success } from 'assets/icons/success.svg';

export const triggerNotification = ({
  message,
  description,
  onClick,
  duration = 3,
  Icon,
  mode
}) => {
  const language = localStorage.getItem('appLanguage') || process.env.REACT_APP_DEFAULT_APP_LANGUAGE;

  let messages;

  if(mode === 'REQUESTS'){
    messages = {
    GR: {
      message: 'Επιτυχής Αποστολή Αίτηματος',
      description: 'Τα στοιχεία του αιτήματος σας αποστάλθηκαν επιτυχώς.'
    },
    UK: {
      message: 'Request Sent Successfully',
      description: 'Your request details have been successfully sent.'
    }
  };
  } else if(mode==='ERROR') {
    messages = {
    GR: {
      message: 'Επιτυχής Αποθήκευση Αίτησης',
      description: 'Τα στοιχεία της αίτησης σας αποθηκεύτηκαν επιτυχώς.'
    },
    UK: {
      message: 'Application Saved Successfully',
      description: 'Your application details have been successfully saved.'
    }
  };
  }


  const selectedMessages = messages[language] || messages.GR;

  notification.open({
    message: message || selectedMessages.message,
    description: description || selectedMessages.description,
    onClick,
    duration,
    icon: Icon ? <Icon /> : <Success />,
  });
};